import Pusher from 'pusher-js';
const pusher = new Pusher('9934448f9c92b1833835',{
  cluster: 'eu',
  encrypted: true,

  // Add any additional configuration options here
});

export default pusher;